import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewAnswerContainer } from '../NewAnswer';
import { getNewAnswerFormStep } from '../../selectors/newAnswer';
import { ENewAnswerModalStep } from '../../types/newAnswer';
import { useApplicationContext } from '../../utils/applicationContext';
import { DEFAULT_MODERATION_LINK } from '../../constants/reviews/moderation';
import { Error } from '../../components/FormCommon/Error';
import { Success } from '../../components/FormCommon/Success';

export interface INewAnswerModalContentContainerProps {
  onClose(): void;
}

export const NewAnswerModalContentContainer = (props: INewAnswerModalContentContainerProps) => {
  const { config } = useApplicationContext();
  const { onClose } = props;
  const step = useSelector(getNewAnswerFormStep);
  const moderationUrl = config.get<string>('newbuilding-reviews-frontend.moderationUrl') || DEFAULT_MODERATION_LINK;

  switch (step) {
    case ENewAnswerModalStep.Answer: {
      return <NewAnswerContainer />;
    }
    case ENewAnswerModalStep.Success: {
      return <Success type="ответ" url={moderationUrl} close={onClose} />;
    }
    case ENewAnswerModalStep.Error: {
      return <Error onClose={onClose} type="Ответ" />;
    }
  }
};
